import { Icon, Text } from '@fairfashion/design-system'
import { useNavigate, useParams } from 'react-router-dom'

import * as Styles from './breadcrumb-item.styles'
import { BreadcrumbItemProps } from './breadcrumb-item.types'

export const BreadcrumbItem = ({ title, url, icon }: BreadcrumbItemProps) => {
  const navigate = useNavigate()
  const params = useParams()

  const getUrl = () => {
    if (!url) {
      return '/'
    }

    let resultUrl = ''
    const urlArray = url.split('/').slice(1)
    urlArray.forEach((item) => {
      if (item.startsWith(':')) {
        const param = item.replace(':', '')
        resultUrl += `/${params[param]}`
      } else {
        resultUrl += `/${item}`
      }
    })

    return resultUrl
  }

  return (
    <Styles.BreadCrumbItemWrapper
      onClick={() => navigate(getUrl())}
      alignItems="center"
    >
      <Icon name={icon} size={16} color="grey_4" />
      <Text variant="p" size="small" color="grey_4">
        {title}
      </Text>
    </Styles.BreadCrumbItemWrapper>
  )
}
